import { Model } from '@vuex-orm/core'

export default class Dashcomponent extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'dashcomponents'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      fixed: this.attr(null),
      width_num: this.attr(null),
      position: this.attr(null),
      type: this.attr(null),
      disable_expand_details: this.attr(null),
      date_range: this.attr(null),
      group_by: this.attr(null),
      group_range: this.attr(null),
      segment_by: this.attr(null),
      select: this.attr(null),
      metric: this.attr(null),
      filters: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Dashcomponent.js